module.exports = __webpack_public_path__ + "img/王浩.cccbec3a.jpg";